import React from "react";
import "./Impressum.css";

export default function Impressum() {
  return (
    <main className="impressum-page">
      {/* Hero / Banner mit leichtem Overlay */}
      <section className="imp-hero">
        <div className="imp-hero-inner">
          <span className="imp-badge">EG-BAU</span>
          <h1>Impressum</h1>
          <p className="imp-sub">Angaben gemäß § 5 TMG</p>
        </div>
      </section>

      {/* Content */}
      <section className="imp-wrap">
        <div className="imp-card">
          <h2>Betreiber der Seite</h2>
          <p>
            <strong>EG-BAU</strong><br />
            Inhaber: Egzon Gjocaj<br />
            Lister Damm 35<br />
            30163 Hannover
          </p>

          <h2>Kontakt</h2>
          <p>
            Telefon: <a href="tel:+4915155629922">+49 151 55629922</a><br />
            E-Mail: <a href="mailto:info@gala-egbau.de">info@gala-egbau.de</a>
          </p>

          <h2>Steuernummer</h2>
          <p>
            Steuernummer gemäß § 22f UStG: <strong>25/114/06157</strong>
          </p>

          <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>
      </section>
    </main>
  );
}
